module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAA3UlEQVQoU6XSTyvFQRTG8c+RP5Gs7LwKSwsWkrJQtl6CvSRZKCvvQ9lYyGuwkBdgjbJSbkiKm6PRXP38ujfdzGKa85z5nufMaUJdmXmClRp+YA63mKzaZUSsl3OULTP3cdgrgC4m0MFMQz+KiN3IzAVcYKSR/MQYXjDV0MtxtUCbmG8luhGxl5kHfaDrAm1hugWVcLS22U69Feip1Xcf/pf0WqAHzP51s5Hv/Au6x1kd83Z9zyDzH6c7nGMcO8NCpfo71rA4wOrb6RE3OO79KGxgaQD0XKBTLA8xvasvnGFUQTXVc24AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/goodsPlan.png
// module id = dJn7
// module chunks = 2